import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { styled } from '@components-shared/src/stitches';
import { SoundLogo } from '@components/icons/SoundLogo';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { useHeaderStore } from '@store/header';
import { iconVariants, SubContainer } from '../styles';
import type { StrokeColor } from '../types';

export const MobileHeader = ({ strokeColor }: { strokeColor: StrokeColor }) => {
  const { open } = useHeaderStore();

  const openHamburger = () => open('hamburger');
  return (
    <div className="flex h-full w-full">
      <SubContainer>
        <AccessibleLink pathnameUri="/">
          <SoundLogo color={strokeColor} />
        </AccessibleLink>
      </SubContainer>
      <div className="relative ml-3 flex h-10 w-fit  items-center justify-end gap-3 md:px-0">
        <div className="flex gap-x-5">
          <div
            className="relative flex h-5 cursor-pointer items-center px-0"
            onClick={openHamburger}
          >
            <IconContainer stroke={strokeColor}>
              <FontAwesomeIcon icon={faBars} size="lg" />
            </IconContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

const IconContainer = styled('div', {
  ...iconVariants,
});
